/* eslint-disable */
const $ = (global.jQuery = require('jquery'))

class Attachment {
    constructor(element) {
        this.$element = $(element)
        this.$clearBtn // not created yet
        this.$filenameDiv
        this.$inputText

        this.injectDecorators()
        this.addEventListeners()
    }

    addEventListeners() {
        this.$inputText.on('click', () => {
            $('input:file', this.$element).trigger('click')
        })

        this.$clearBtn.on('click', () => {
            this.replaceInput($('input:file', this.$element))
        })

        this.$element.on('change', 'input:file', (event) => {
            this.inputChanged(event.target)
        })
    }

    injectDecorators() {
        $('.fui-input-container', this.$element)
            .append('<span class="file-upload__text">Add attachment</span>')
            .append('<span class="file-upload__filename"></span>')
            .append('<span class="file-upload__clear"></span>')
            .append(
                '<p class="file-upload__info">More than one attachment can be added by selecting multiples files in the select box.</p>'
            )

        this.$clearBtn = $('.file-upload__clear', this.$element)
        this.$filenameDiv = $('.file-upload__filename', this.$element)
        this.$inputText = $('.file-upload__text', this.$element)
    }

    replaceInput($input) {
        $input.replaceWith($input.val('').clone(true))
        this.$filenameDiv.text('No files chosen')
        this.$clearBtn.text('')
    }

    inputChanged(input) {
        let fileName = $(input).val().split('\\').pop()
        let fileCount = input.files.length
        this.$clearBtn.text('Remove files')

        if (fileCount > 1) {
            this.$filenameDiv.text(fileCount + ' files attached')
        } else {
            // equals 1
            this.$filenameDiv.text(fileName)
        }
    }
}

export default Attachment
